import React, { useState, useRef } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Logo from '~/utils/images/logo.svg';
import './Header.css';

import ProfileDropdown from '~/containers/ProfileDropdown/ProfileDropdown';
import localforage from 'localforage';
import { RootState } from '~/redux/store';
import { logout } from '~/api/auth';
import { logoutSuccess } from '~/reducers/auth';
import { VENDOR_NAME_KEY } from '~/theme/vendorConstants';
import { applyVendorTheme } from '~/theme/vendorTheme';
import { useOnClickOutside } from '~/helpers/helpers';
import { Roles } from '~/enums/Roles';
import { CreateMenu } from './CreateMenu/CreateMenu';
interface DispatchProps {
  logoutSuccess: typeof logoutSuccess;
}

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<DispatchProps>;

const Header = (props: Props) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const history = useHistory();
  const { logoutSuccess, profileImage, userRole } = props;
  const vendor = sessionStorage.getItem(VENDOR_NAME_KEY);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowDropdown(false));

  const onLogout = () => {
    logout().then(() => {
      setShowDropdown(false);
      localforage.clear();
      sessionStorage.removeItem(VENDOR_NAME_KEY);
      applyVendorTheme();
      logoutSuccess();
    });
    history.push('/login');
  };

  const showCreateCTA =
    userRole === Roles.Vcm ||
    userRole === Roles.Superadmin ||
    userRole === Roles.Pm ||
    userRole === Roles.PM_FREE;

  return (
    <div id='header'>
      {vendor ? (
        <div className='vendor-logo pointer' onClick={() => history.push('/building')}>
          <span className='vendor-logo-title'>Community</span>
          <span className='vendor-logo-subtitle'>
            powered by <img src={Logo} alt='Cobu' className='vendor-logo-cobu' />
          </span>
        </div>
      ) : (
        <img
          className='logo pointer'
          src={Logo}
          alt='Cobu'
          onClick={() => history.push('/building')}
        />
      )}
      <div className='header-nav-menu'>
        {showCreateCTA && (
          <div className='menu-item'>
            <CreateMenu />
          </div>
        )}
        {!vendor && (
          <div className='position-relative' ref={ref}>
            <img
              src={profileImage}
              alt='Profile'
              className='profile-image pointer'
              onClick={() => setShowDropdown(!showDropdown)}
            />
            {showDropdown && <ProfileDropdown email='' onLogout={onLogout} />}
          </div>
        )}
      </div>
    </div>
  );
};
function mapDispatchToProps(): DispatchProps {
  return {
    logoutSuccess
  };
}
function mapStateToProps(state: RootState) {
  return {
    profileImage: state.auth.user.profileImage,
    userRole: state.auth.userRole
  };
}
export default connect(mapStateToProps, mapDispatchToProps())(Header);
